import useSWR from 'swr';
import { backendClient } from '@/lib/api-client';
import type { HomeDeadline } from './useHomeDashboard';

export type HomeDeadlinesResponse = {
  upcoming_deadlines: HomeDeadline[];
};

export function homeDeadlinesRequest(timezone: string, weekStartsOn: 0 | 1) {
  return {
    key: ['/home/deadlines', timezone, weekStartsOn] as const,
    params: {
      timezone,
      week_starts_on: weekStartsOn,
    },
  };
}

export function useHomeDeadlines({
  timezone,
  weekStartsOn,
  enabled = true,
}: {
  timezone: string;
  weekStartsOn: 0 | 1;
  enabled?: boolean;
}) {
  const request = homeDeadlinesRequest(timezone, weekStartsOn);
  const { data, error, isLoading, mutate } = useSWR<HomeDeadlinesResponse>(
    enabled ? request.key : null,
    async () => {
      const response = await backendClient.get<HomeDeadlinesResponse>('/home/deadlines', {
        params: request.params,
      });
      return response.data;
    },
    {
      refreshWhenHidden: false,
      revalidateOnFocus: true,
    },
  );

  return {
    deadlines: data?.upcoming_deadlines ?? [],
    isLoading: enabled ? isLoading : false,
    isError: error,
    mutate,
  };
}
